'use strict';

import './callcenter.edit.ctrl';

export default angular
  .module('main.callcenter', [
    'main.callCenterEdit.controller'
  ])
  .name;
